import { registerEventListeners } from "./events/event-register"
import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const moduleRegister: ModuleRegisterFn = (context: ModuleRegisterContext) => {
  registerEventListeners(context.eventBus)
  console.log("login module registered with context", context)
}

export default moduleRegister
